/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramClickControllerCreateMutationRequest,
  TelegramClickControllerCreateMutationResponse,
  TelegramClickControllerCreate401,
} from '../types/TelegramClickControllerCreate.ts';

function getTelegramClickCreateUrl() {
  const res = { method: 'POST', url: `/api/telegram/click` as const };
  return res;
}

/**
 * {@link /api/telegram/click}
 */
export async function telegramClickCreate(
  data: TelegramClickControllerCreateMutationRequest,
  config: Partial<RequestConfig<TelegramClickControllerCreateMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramClickControllerCreateMutationResponse,
    ResponseErrorConfig<TelegramClickControllerCreate401>,
    TelegramClickControllerCreateMutationRequest
  >({ method: 'POST', url: getTelegramClickCreateUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
